import { defineComponent as _defineComponent } from 'vue';
import { useTelemetry } from '@/plugins/telemetry';
import IMAGE_1 from '@/assets/202412_bnr900_900_1.png';
import IMAGE_2 from '@/assets/202412_bnr900_900_3.png';
export default /*#__PURE__*/_defineComponent({
  __name: 'banner-panel',
  setup: function setup(__props) {
    var LP_URL_A = 'https://store.legalscape.jp/?utm_source=legalscape&utm_medium=referral&utm_campaign=top_banner_202403';
    var LP_URL_B = 'https://store.legalscape.jp/p/9784785731328?utm_source=legalscape&utm_medium=referral&utm_campaign=top_banner_202403';
    var banners = [{
      id: 'store-lp-2',
      url: LP_URL_B,
      image: IMAGE_2,
      alt: 'Top banner 2'
    }, {
      id: 'store-lp-1',
      url: LP_URL_A,
      image: IMAGE_1,
      alt: 'Top banner 1'
    }];
    var telemetry = useTelemetry();
    var route = useRoute();
    var handleClick = function handleClick() {
      telemetry.sendClickTelemetry({
        button: 'top-banner__store-lp'
      }, route);
    };
    return {
      __sfc: true,
      LP_URL_A: LP_URL_A,
      LP_URL_B: LP_URL_B,
      banners: banners,
      telemetry: telemetry,
      route: route,
      handleClick: handleClick
    };
  }
});